const contactInfo = {
  email: 'info@briqconstruction.com',
  phone: '+91 9999383756',
  whatsappNumber: '919999383756',
  address: 'Sector 49, Gurugram, Haryana 122018',
  companyName: 'Briq Construction',
  workingHours: 'Mon – Sat, 9:00 AM – 7:00 PM',
  emailApiUrl: 'https://qrmbcznwx8.execute-api.ap-southeast-2.amazonaws.com/send-email',
};

export const getWhatsAppLink = (message = '') => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${contactInfo.whatsappNumber}${message ? `?text=${encodedMessage}` : ''}`;
};

export default contactInfo;
